<div class="modal-content" [class.shadow-none]="false">
  <div class="modal-header align-items-start">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Add family members</h2>
    </div>
  </div>
  <div class="modal-body">
    @if (!addChildAccount) {
      <div class="row spacing-30">
        <div class="col-12 d-flex ">
          <app-input-component
            [label]="'Invite member by  email'"
            [placeholder]="'Invite member by  email'"
            [(value)]="email"
            class="w-100 me-3"
          />
          <app-button
            [label]="'Add'"
            [variant]="'primary'"
            (clicked)="addUserByEmail()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col w-100 d-flex justify-content-center">
          <app-button
            [label]="'Add child without account'"
            [variant]="'primary'"
            (clicked)="addChildAccount = !addChildAccount"
          />
        </div>
      </div>
    }
    @if (addChildAccount) {
      <div class="row g-4 spacing-15">
        <div class="col-lg-6 col-12">
          <app-input-component
            [label]="'First Name'"
            [placeholder]="'First Name'"
            [type]="'text'"
            [(value)]="tempUser.firstName"
          />
        </div>
        <div class="col-lg-6 col-12">
          <app-input-component
            [label]="'Last Name'"
            [placeholder]="'Last Name'"
            [type]="'text'"
            [(value)]="tempUser.lastName"
          />
        </div>
      </div>
      <div class="row g-4 spacing-15">
        <div class="col-lg-6 col-6">
          <app-input-component
            [label]="'Date of birth'"
            [placeholder]="'Date of birth'"
            [type]="'date'"
            [(value)]="tempUser.date_of_birth"
          />
        </div>
        <div class="col-lg-6 col-6">
          <app-input-component
            [label]="'Riding Club'"
            [placeholder]="'Riding Club'"
            [type]="'text'"
            [(value)]="tempUser.riding_club"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-fileorini
            [accept]="'image/*'"
            (filesChanged)="tempUserProfileImage = $event[0]"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col d-flex justify-content-end gap-3">
          <app-button
            [label]="'Cancel'"
            [variant]="'outline'"
            (clicked)="addChildAccount = false"
          />
          <app-button
            [label]="'Add Child'"
            [variant]="'primary'"
            (clicked)="addUserWithoutAccount()"
          />
        </div>
      </div>
    }
  </div>
</div>
